export enum SetupAppName {
    CDP_MY = "cdp_my",
    CREDENTIALING = "credentialing"
}